import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import { pascalCase } from 'change-case'
import { MainBodyContent } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import GeneralInformation from '../Form/GeneralInformation'
import ReferenceBG from '../Form/ReferenceBG'
import BankGuaranteeInformation from '../Form/BankGuaranteeInformation'
import ProjectManager from '../../../Form/ProjectManager'
import VendorContact from '../Form/VendorContact'
import Attachment from '../Form/Attachment'
import CommentHistory from '../../../Form/CommentHistory'
import { bgVendorReportPath, bgVendorDetailPath } from 'routes'
import { DocumentTypeContent } from './styled'
import { appLoading } from 'ducks/app'
import { getBankGuaranteeDetail, updateBankGuarantee, deleteBankGuarantee } from 'ducks/bankGuarantee'
import { validateOriginalForm } from '../../../helper'
import { StatusTag } from '../../../styled'

const EditBankGuarantee = (props) => {
  const { valueForm, change, username, history } = props
  const [mainFormClickSave, setMainFormClickSave] = React.useState(false)
  const [submit, setSubmit] = React.useState(false)
  const [showConfirmDelete, setShowConfirmDelete] = React.useState(false)

  React.useEffect(() => {
    const id = props.match.params.id || ''

    props.getBankGuaranteeDetail(id)
  }, [])

  React.useEffect(() => {
    if ((valueForm.createdBy !== username && valueForm.status === 0)) {
      history.push(bgVendorDetailPath(valueForm.id))
    }
  }, [valueForm])

  const onSubmitCreateForm = (values) => {
    if (mainFormClickSave) {
      const { updateBankGuarantee, history } = props
  
      var errors = validateOriginalForm(values)
  
      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        setMainFormClickSave(false)
        throw new SubmissionError(errors)
      } else {
        setMainFormClickSave(false)
        updateBankGuarantee(values, submit, history)
      }
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Bank Guarantee - ${valueForm.documentNumber ?? 'Edit'}`}
          <StatusTag status={valueForm.status} style={{ marginLeft: '10px' }}>{valueForm.statusName}</StatusTag>
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'Bank Guarantee', link: true, onClick: () => props.history.push(bgVendorReportPath) },
              { key: 'BGEdit', content: 'Edit', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
        </div>
      }
    >
      <form onSubmit={props.handleSubmit((values) => onSubmitCreateForm(values))}>
        <DocumentTypeContent>Document Type : {pascalCase(valueForm.createType)}</DocumentTypeContent>
        <GeneralInformation valueForm={valueForm} change={change} />
        <ReferenceBG valueForm={valueForm} change={change} />
        <BankGuaranteeInformation valueForm={valueForm} change={change} />
        <ProjectManager />
        <VendorContact change={change} formName='formBankGuarantee' />
        <Attachment valueForm={valueForm} change={change} />
        {valueForm.status !== 0 && (valueForm.comments || []) > 0 ? <CommentHistory /> : null}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
          <div>
            {valueForm.status === 0 && valueForm.createdBy === username && (valueForm.references || []).length === 0 ?
              <Button
                type='button'
                content='Delete'
                color='red'
                icon='trash'
                labelPosition='right'
                onClick={() => setShowConfirmDelete(true)}
              /> : null}
          </div>
          {
            (valueForm.createdBy === username && valueForm.status === 0) ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  type='submit'
                  content='Save'
                  icon='save'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setMainFormClickSave(true)
                    setSubmit(false)
                  }}
                />
                <Button
                  type='submit'
                  content='Save & Submit'
                  color='blue'
                  icon='save'
                  labelPosition='right'
                  onClick={() => {
                    setMainFormClickSave(true)
                    setSubmit(true)
                  }}
                />
              </div> : null
          }
        </div>
      </form>
      <Confirm
        open={showConfirmDelete}
        header='Delete Bank Guarantee'
        content='Are you sure to delete this document?'
        confirmButton='Delete'
        onCancel={() => setShowConfirmDelete(false)}
        onConfirm={() => {
          props.deleteBankGuarantee(valueForm.id, props.history)
          setShowConfirmDelete(false)
        }}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const vf = getFormValues('formBankGuarantee')(state) || {}
  const username = localStorage.getItem('username')
  return ({
    username,
    valueForm: vf,
    initialValues: {
      ...state.bg.bankGuarantee.data
    },
  })
}

const mapDispatchToProps = {
  appLoading,
  getBankGuaranteeDetail,
  updateBankGuarantee,
  deleteBankGuarantee
}

const validate = (values) => {
  let errors = validateOriginalForm(values)

  return errors
}

const EditBankGuaranteeForm = reduxForm({
  form: 'formBankGuarantee',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(EditBankGuarantee)

export default connect(mapStateToProps, mapDispatchToProps)(EditBankGuaranteeForm)
